import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const GetAllSetupsJobGrade = async ({
  page,
  limit,
  with_than,
  status = true,
  use_for = "dropdown",
  search,
  lookup,
  job_type_uuid,
  sub_category_uuid,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  queryList.push(`query=${encodeURIComponent(search ?? "")}`);
  if (status) queryList.push(`status=${status}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  const jobTypeUuids = Array.isArray(job_type_uuid)
    ? job_type_uuid
    : job_type_uuid
      ? [job_type_uuid]
      : [];
  jobTypeUuids.forEach((uuid) => {
    if (uuid) queryList.push(`job_type_uuid[]=${encodeURIComponent(uuid)}`);
  });
  const subCategoryUuids = Array.isArray(sub_category_uuid)
    ? sub_category_uuid
    : sub_category_uuid
      ? [sub_category_uuid]
      : [];
  subCategoryUuids.forEach((uuid) => {
    if (uuid) queryList.push(`sub_category_uuid[]=${encodeURIComponent(uuid)}`);
  });

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/job-grade?${queryList.join(
      "&"
    )}`,
    {
      params: {
        lookup,
        with_than,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const GetSetupsJobGradeById = async ({uuid, lookup}) => {
    const queryList = [];
    if (uuid) queryList.push(`uuid=${uuid}`);
    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/job-grade/view?${queryList.join('&')}`,
        {
            params: {
                uuid,
                lookup,
            },
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};